











import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
  components: {},
})
export default class Button extends Vue {
  @Prop(String) public title?: string
  @Prop(Boolean) public primary?: boolean
  @Prop(Boolean) public disabled?: boolean

  public click() {
    this.$emit('click')
  }
}
